// eslint-disable-next-line no-restricted-imports
import { DatePicker } from "antd";
import dateFnsConfig from "rc-picker/lib/generate/dateFns";

export const AntDatePicker = DatePicker.generatePicker<Date>(dateFnsConfig);
